module.exports = __webpack_public_path__ + "img/img-8.212fa649.webp";